import createIcon from '../../createIcon';

/**
 * @component @name Forest
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTJMOSAyTDIgMTJIMy44NkwwIDE4SDdWMjJIMTFWMThIMThMMTQuMTQgMTJIMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuMTQgMTJIMjJMMTUgMkwxMi42MSA1LjQxTDE3LjkyIDEzSDE1Ljk3TDE5LjE5IDE4SDI0TDIwLjE0IDEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDE5SDEzVjIySDE3VjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Forest = createIcon('Forest', [
  ['path', { d: 'M16 12L9 2L2 12H3.86L0 18H7V22H11V18H18L14.14 12H16Z', key: '12vuj0' }],
  [
    'path',
    { d: 'M20.14 12H22L15 2L12.61 5.41L17.92 13H15.97L19.19 18H24L20.14 12Z', key: '1npa14' },
  ],
  ['path', { d: 'M17 19H13V22H17V19Z', key: '17pbph' }],
]);

export default Forest;
